module.exports = __webpack_public_path__ + "static/media/bg3.42a3b382.png";